import Vue from 'vue';
import VueAuthPopup from './AuthPopup.vue';

let instance;

function initInstance(url) {
  if (instance) {
    instance.$destroy();
  }
  instance = new (Vue.extend(VueAuthPopup))({
    el: document.createElement('div'),
    data() {
      return {
        url,
      };
    },
  });
  document.body.appendChild(instance.$el);
}

function AuthPopup(url) {
  if (url !== instance?.url) {
    initInstance(url);
  } else {
    instance.show = true;
  }
}

AuthPopup.install = () => {
  Vue.use(VueAuthPopup);
};

Vue.prototype.$authPopup = AuthPopup;

export default AuthPopup;
